import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { useForm } from "react-hook-form";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";
import { useParams } from "react-router-dom";
import { ProductDetails } from "./ProductDetails";
import ProductReview from "./ProductReview";
import WSBackButton from "../../Components/BackButton/BackButton";
import WSButton from "../../Components/Button/WSButton";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import http from "../../commonFunctions/httpClient";

export const ProductView: React.FC<any> = React.memo((props) => {
  const { control, handleSubmit } = useForm();
  const navigate = useNavigate();
  const params = useParams();
  const {showMessage} = useSnackbar();
  const id: any = params?.id;
 useEffect(() => {
        breadCrumbsStore.updateBreadCrumbs([
            { 'My Products': '/vendor-product/list' },
            { [!id ? 'Product View' : '']: '/' },
        ]);
    }, [id]);

  const tabsData: any[] = [
    { label: "Product Details", content: <ProductDetails /> },
    { label: "Review", content: <ProductReview /> },
  ];

  const onSubmit = async (data: any) => {
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleEditClick =  () =>{
    if (id) {
      navigate(`/vendor-product/edit/${id}`)
    }
  }
  
  const handleRemoveClick = async () => {
    if (!id) {
      showMessage("No product ID found", "error");
      return;
    }
    if (!window.confirm(`Delete product permanently? ID: ${id}`)) {
      return;
    }

    try {
      await http.del(`pharmacy/products/${id}`);
      showMessage("product deleted succesfully","success")
      navigate(`vendor-product/list`)
      
    } catch (error : any) {
      console.error("delete error",error);
      showMessage(
         error.response?.data?.message || "Failed to delete product", 
        "error"
      )


      
    }
  };


  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Edit Product",
      size: "medium",
      //   onClick: handleCancelClick,
      variant: "outlined",
      color: "primary",
      sx: {
        color: "#FFFFFF",
        backgroundColor: "#098963",
        border: "1px solid #098963",
        borderRadius: 8,
      },
    },
    {
      type: "button",
      text: "Remove Product",
      //   loading: loading,
      size: "medium",
      onClick: handleSubmit(onSubmit),
      buttonType: "submit",
      variant: "outlined",
      color: "primary",
      sx: {
        color: "#098963",
        backgroundColor: "#FFFFFF",
        border: "1px solid #098963",
        borderRadius: 8,
      },
    },
  ];

  return (
    <>
      <WSBackButton id="btnScheduleBack" url={"/vendor-product/list"} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper
          elevation={0}
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            marginTop: 30,
            paddingBottom: 25,
            borderRadius: "8px",
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            sx={{ marginBottom: 2 }}
          >
            {/* Left Heading */}
            <Grid item xs={12} sm={"auto"}>
              <Typography variant="h6" fontWeight={400}>
                Product View
              </Typography>
            </Grid>

            {/* Right Buttons */}
            <Grid
              item
              xs={12}
              sm={"auto"}
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              <WSButton
                id="editproduct"
                type="button"
                label="Edit Product"
                size="medium"
                variant="outlined"
                color="primary"
                onClick={handleEditClick}
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  border: "1px solid #098963",
                  borderRadius: 8,
                  width: "8rem",
                }}
              />

              <WSButton
                id="removeProduct"
                type="button"
                label="Remove Product"
                size="medium"
                variant="outlined"
                color="primary"
                onClick={handleRemoveClick}
                sx={{
                  borderRadius: 8,
                  width: "10rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <WSTabs
                id="tabs"
                control={control}
                name="tabs"
                tabs={tabsData}
                justifyTabs="flex-start"
              />
            </Grid>
          </Grid>
        </Paper>
      </form>
    </>
  );
})
;
